import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-help-update',
    templateUrl: './help-update.component.html',
    styleUrls: ['./help-update.component.css'],
    standalone: false
})
export class HelpUpdateComponent implements OnInit {

  constructor() {

  }

  ngOnInit(): void {

  }

}
